// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"1a86c276","200":"ef50f95f","239":"b053d25b","287":"ae79a59a","290":"26372c6f","453":"6d0239cb","550":"9d4f3a64","608":"98ec1b31","732":"10ba7569","841":"e2747626","977":"7df2fc9e"}[chunkId] + ".chunk.js";
};